import React, { Component } from 'react'
import { throttle } from 'lodash'
import { formValueSelector } from 'redux-form'
import { connect } from 'react-redux'

import Button from '../../elements/Button/Button'
import ImersiveHeader from '../../elements/ImersiveHeader'
import StatementsFilterForm from '../StatementsFilterForm'
import {
  ButtonContainerDesktop,
  ButtonContainerMobile,
  Filter,
  FilterContainer,
  FilterClosed,
  FilterOpened,
  FilterWrapper
} from './styles'

class StatementsFilter extends Component {
  constructor(props) {
    super(props)

    this.state = {
      isOpen: false,
      isFixed: true,
      currentValues: {}
    }
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll)
    this.handleScroll()
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll)
  }

  handleScroll = throttle(
    () => {
      const footer = document.getElementById('footer')
      const currentScroll = footer.getBoundingClientRect().top - window.innerHeight > 0
      if (currentScroll > 0) {
        this.setState({
          isFixed: true
        })
      } else {
        this.setState({
          isFixed: false
        })
      }
    },
    50,
    {
      maxWait: 1000
    }
  )

  render() {
    const openFilter = () => {
      this.setState({
        isOpen: true
      })
    }

    const closeFilter = () => {
      this.setState({
        isOpen: false
      })
    }

    const onSubmitFilter = values => {
      const changedValues = {
        plate: values.plate,
        placas: values.placas,
        month: values.month,
        type: values.type,
        year: values.year,
        periodo: values.periodo,
        diaDaSemana: values.diaDaSemana,
        rangeDates: values.rangeDates
      }

      if (this.props.onFilter) {
        this.props.onFilter(changedValues)
      }

      this.setState({
        isOpen: false,
        currentValues: changedValues
      })
    }

    return (
      <FilterWrapper>
        <Filter isOpen={this.state.isOpen} isFixed={this.state.isFixed}>
          <FilterContainer isOpen={this.state.isOpen}>
            <FilterClosed isOpen={this.state.isOpen}>
              <ButtonContainerMobile>
                <Button buttonType="skyBlue" text="Filtrar" onClick={openFilter} />
              </ButtonContainerMobile>
              <ButtonContainerDesktop>
                <Button buttonType="transparent" text="Filtrar" onClick={openFilter} />
              </ButtonContainerDesktop>
            </FilterClosed>
            <FilterOpened isOpen={this.state.isOpen}>
              <ImersiveHeader text="Voltar" back={closeFilter} />
              <StatementsFilterForm
                onClick={closeFilter}
                onSubmit={onSubmitFilter}
                accountPlans={this.props.accountPlans}
                accountId={this.props.accountId}
                unsetResults={this.props.unsetResults}
                setHasValePedagio={this.props.setHasValePedagio}
                hasValePedagio={this.props.hasValePedagio}
              />
            </FilterOpened>
          </FilterContainer>
        </Filter>
      </FilterWrapper>
    )
  }
}

StatementsFilter.defaultProps = {
  plate: ''
}

const mapStateToProps = state => {
  const selector = formValueSelector('statementsFilter')
  return {
    plate: selector(state, 'plate')
  }
}

export default connect(mapStateToProps)(StatementsFilter)



// WEBPACK FOOTER //
// ./src/app/modules/StatementsFilter/index.js